export { default as Email } from './Email';
export { default as FaceBook } from './FaceBook';
export { default as Instagram } from './Instagram';
export { default as Twitter } from './Twitter';
export { default as Pinterest } from './Pinterest';
export { default as Logo } from './Logo';
export { default as Mouse } from './Mouse';



// WEBPACK FOOTER //
// ./src/components/shared/icons/index.js